<div *ngIf="bookingItem$ | async; let bookingItem">

  <ub-card [rounded]="true">
    <h1 title>{{ bookingItem.doc.name }}</h1>
    <div actions>
      <ub-label label="State" [text]="workflow.title" i18n-label></ub-label>
    </div>
  </ub-card>

  <ng-container *ngIf="bookableOptions$ | async; let bookableOptions">
    <eas-booking-item-integration-option *ngFor="let option of bookableOptions" [bookingItemOption]="option"
      ></eas-booking-item-integration-option>
  </ng-container>

</div>
